import { useContext } from 'react';
import { store } from '../store';
import { usePostRequest } from '../../core/coreUseRequest';

/** useCreateCharge ::  {} */
export default function useApplyPayment() {
	const { dispatch } = useContext(store);

	return usePostRequest({
		url: '/pay/client/apply/payment',
		dispatch,
		queryName: 'getClientInvoices',
		successFn: () =>
			dispatch({
				type: 'close dialog'
			})
	});
}
